import { faUser, faBullhorn } from "@fortawesome/free-solid-svg-icons";
import OptionsCheckboxFilter, {
  OptionItem,
} from "../options-checkbox-filter/OptionsCheckboxFilter";
import { BaseFilterProps } from "interfaces/filter-component-base";
import "./InviteTypeFilter.scss";

const inviteTypeOptions: OptionItem[] = [
  {
    label: "Personal",
    value: "personal",
    description: "Direct invitations",
    icon: faUser,
    iconClassName: "personal",
  },
  {
    label: "Campaign",
    value: "campaign",
    description: "Campaign invites",
    icon: faBullhorn,
    iconClassName: "campaign-checkbox",
  },
];

const InviteTypeFilter = (props: BaseFilterProps) => {
  return <OptionsCheckboxFilter {...props} options={inviteTypeOptions} />;
};

export default InviteTypeFilter;
